'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dUser$002dName$0024$0024anon$0024137 from "./presto.types$-User-Name$$anon$137.js";
var $p;
/** @constructor */
function $c_Lpresto_types$UserName$() {
  this.cd2 = null;
  this.cd3 = false;
  this.cd4 = null;
  this.cd5 = false;
}
export { $c_Lpresto_types$UserName$ as $c_Lpresto_types$UserName$ };
$p = $c_Lpresto_types$UserName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$UserName$;
/** @constructor */
function $h_Lpresto_types$UserName$() {
}
export { $h_Lpresto_types$UserName$ as $h_Lpresto_types$UserName$ };
$h_Lpresto_types$UserName$.prototype = $p;
$p.cHi = (function() {
  if ((!this.cd3)) {
    this.cd2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.cd3 = true;
  }
  return this.cd2;
});
$p.cI6 = (function() {
  if ((!this.cd5)) {
    this.cd4 = new $j_presto$002etypes$0024$002dUser$002dName$0024$0024anon$0024137.$c_Lpresto_types$UserName$$anon$137(this);
    this.cd5 = true;
  }
  return this.cd4;
});
var $d_Lpresto_types$UserName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$UserName$, "presto.types$UserName$", ({
  a34: 1,
  D: 1
}));
export { $d_Lpresto_types$UserName$ as $d_Lpresto_types$UserName$ };
var $n_Lpresto_types$UserName$;
function $m_Lpresto_types$UserName$() {
  if ((!$n_Lpresto_types$UserName$)) {
    $n_Lpresto_types$UserName$ = new $c_Lpresto_types$UserName$();
  }
  return $n_Lpresto_types$UserName$;
}
export { $m_Lpresto_types$UserName$ as $m_Lpresto_types$UserName$ };
//# sourceMappingURL=presto.types$-User-Name$.js.map
